var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s-main-container"},[_c('v-select',_vm._g(_vm._b({staticClass:"t-select",attrs:{"options":_vm.options}},'v-select',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }